// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1MMNy","modalForm":"UpgradeEpcsModal_modalForm__2Dx1t","modalFooter":"UpgradeEpcsModal_modalFooter__1XBmx"};